<template>
  <Layout kind="narrow">
    <div class="section">
      <div class="content">
        <h1>{{ $t("Browse") }}</h1>
        <hr />
        <ul v-for="entry in directoryData.entries" class="is-unstyled">
          <h3>{{ entry.index }}</h3>

          <directory-tree :title="entry.index" :documents="entry.documents"></directory-tree>

          <hr />

          <!-- <b-collapse
            class="card"
            animation="slide"
            v-for="(doc, index) of entry.documents"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index"
          >
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button"
            >
              <p v-if="doc.docId" class="card-header-title">
                <RouterLink
                :to="{ name: 'Document', params: { documentId: doc.docId } }"
                >
                {{ doc.title }}
                  </RouterLink>
              </p>
              <p v-else class="card-header-title">
                          <directory-tree :title="doc.title" :documents="doc.documents"></directory-tree>

                {{ doc.title }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'caret-down' : 'caret-up'">
                </b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="content">
                {{ doc.title }}
              </div>
            </div>
          </b-collapse> -->
        </ul>


        <!-- <ul v-for="entry in directoryData.entries" class="is-unstyled">
          <h3>{{ entry.index }}</h3>
          <ul class="is-unstyled">
            <li v-for="doc in entry.documents">
              <RouterLink
                v-if="doc.docId"
                :to="{ name: 'Document', params: { documentId: doc.docId } }"
              >
                {{ doc.title }}
              </RouterLink>
              <div v-else>
                <RouterLink
                  :to="{
                    name: 'StaticDirectory',
                    params: { documentTitle: doc.title },
                  }"
                >
                  {{ doc.title }}
                </RouterLink>
              </div>
            </li>
          </ul>
          <hr />
        </ul> -->


      </div>
    </div>
  </Layout>
</template>

<script>

import DirectoryTree from '@/components/DirectoryTree.vue'
export default {
  components: {
    DirectoryTree
  },
  data() {
    return {
      directoryData: {},
    };
  },

  async mounted() {
    const directoryData = await fetch(
      "staticDirectory/staticDirectory.json"
    ).then((res) => res.json());
    this.directoryData = directoryData;
  },
};
</script>

<style>
.is-unstyled {
  list-style: none !important;
  margin-left: 0 !important;
}
</style>
